import env from './environment';

export const URL_AUTH_TOKEN = () => `${env.HOST}/oauth-end/oauth2/token`;
export const URL_ADDRESS_QUERY = cep =>
  `${env.HOST}/rs/v1.0/corporativo/cep/${cep}`;
export const URL_SAVE_COTATION = () =>
  `${env.HOST}/rs/v1.0.3/cotacao/capitalizacao`;
export const URL_UFS = () =>
  `${env.HOST}/rs/v1.0/corporativo/dominios/unidade-federativa `;
export const URL_MARITAL_STATES = () =>
  `${env.HOST}/rs/v1.0/corporativo/dominios/estado-civil`;
export const URL_PROFESSIONS = () =>
  `${env.HOST}/rs/v2/corporativo/profissoes?unidade=CBO`;
export const URL_COUNTRIES = () =>
  `${env.HOST}/rs/v1.0/corporativo/dominios/nacionalidade`;
export const URL_INCOME_GROUP = () =>
  `${env.HOST}/rs/v1.0/corporativo/faixa/renda/origem?des_origem=CORPORATIVO`;
export const URL_PAYMENT = () => `${env.HOST}/rs/v2/propostas`;
export const URL_DOC_LIST = (process, product) =>
  `${env.HOST}/rs/v1.0/documentos/processos/${process}?produto=${product}`;
export const URL_DOC_UPLOAD = process =>
  `${env.HOST}/rs/v1.0/documentos/processos/${process}/upload`;
export const URL_PERSON_QUERY = cpf =>
  `${env.HOST}/rs/visao360/v1/pessoa/${cpf}`;
export const URL_LOGIN = () => `${env.HOST}/public/oauth2/token`;
export const URL_PHONE_TOKEN = () => `${env.HOST}/rs/v1/token/sms`;
export const URL_PHONE_TOKEN_VALIDATION = () =>
  `${env.HOST}/rs/v1/token/validacao`;
export const URL_TO_SHARE = () => `${window.location.origin}/capitalizacao`;
export const URL_WHATSAPP_SHARE = text =>
  `https://api.whatsapp.com/send?text=${text} ${URL_TO_SHARE()}`;
export const URL_FACEBOOK_SHARE = text =>
  `https://www.facebook.com/sharer/sharer.php?u=${URL_TO_SHARE()}&quote=${text}`;
export const URL_TWITTER_SHARE = text =>
  `https://twitter.com/intent/tweet?url=${URL_TO_SHARE()}&via=caixaseguradora&text=${text}`;
export const URL_UNIT_PRODUCT = () =>
  `${env.HOST}/rs/v1.0/produto/unidades-negocios/${env.SYSTEM_UNIT}/produtos`;
export const URL_TITLES = (product, version) =>
  `${env.HOST}/rs/v1.0/produtos/unidades-negocios/${env.SYSTEM_UNIT}/produtos/${product}/versoes/${version}/ofertas/titulos`;
export const URL_BASE_CHAT =
  'https://caixaseguradora.secure.force.com/LiveAgentDirectChat?button_id=5731R000000fxd7';
export const URL_PROPOSAL = () =>
  `${env.HOST}/rs/v1.0.2/proposta/capitalizacao`;
export const URL_IBC = token =>
  `${env.HOST}/rs/v1.0/ibc/usuario/informacao/${token}`;

export const URL_PDF = productCode =>
  `https://lojaonline.caixaseguradora.com.br/Docs Condicoes Gerais/${
    productCode === 225
      ? 'Cap-Ganhador-Condicoes-Gerais-Pagamento-Mensal-PM225.pdf'
      : 'Cap-Ganhador-Condicoes-Gerais-Pagamento-Unico-PU417.pdf '
  }`;

export const URL_LGPD_CONSENT = (businessProcess, cpf) =>
  `${env.HOST}/lgpd/v1/consentimentos/processo-negocio/${businessProcess}/pessoas/${cpf}`;
